import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';

import { VisitorUpfrontRegistrationListComponent } from './component/visitor-upfront-registration-list.component';
import { MatTableModule as MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';

@NgModule({
  declarations: [
    VisitorUpfrontRegistrationListComponent,
  ],
  imports: [
    CommonModule,
    DictionaryModule,

    FormsModule,
    ReactiveFormsModule,
    CommonTranslationModule,
    CommonUIModule,
    CommonLayoutModule,
    MatSortModule,
    MatTableModule

  ],
  exports: [
    VisitorUpfrontRegistrationListComponent
  ]
})
export class VisitorUpfrontRegistrationListModule { }
